import Layout from '../HorizontalMenu/Menu';
import Navbar from '../HorizontalMenu/Navbar';
import React from 'react';
import '../global/GlobalCSS.css'
import ImoDcsPartial from './partials/ImoDcsPartial';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../index';
import { setVesselID } from '../Store/Generic/ReportingSlice';
import { Col, Container, Label, Row } from 'reactstrap';
import Select from 'react-select';
import { customStyle } from 'shared/CommonCSS';

const ImoDcs = () => {
  /** State variables */
  const dispatch = useDispatch();
  const { Vessels, VesselID } = useSelector((state: RootState) => state.Reporting);
  const handleVesselSelectionChanges = (e: any) => {
    dispatch(setVesselID(e.id));
  }
  const vessel = Vessels.find((rec: any) => rec.id === VesselID);
  /** State variables end */

  return (
    <React.Fragment>
      <Layout children={Navbar} />
      <div className='page-content'>
        <Container fluid>
          <Row>
            <Col sm={4} className='ps-0'>
              <Label className='mb-0'>Select vessel</Label>
              <Select
                options={Vessels.filter((item: any) => item.display === true) as any[]}
                getOptionLabel={(option: any) => option.vessel_name}
                getOptionValue={(option: any) => option.id}
                onChange={(e: any) => handleVesselSelectionChanges(e)}
                menuPortalTarget={document.body}
                styles={customStyle}
                defaultValue={{
                  id: VesselID,
                  vessel_name: vessel?.vessel_name
                }}
              />
            </Col>
            <Col sm={8} className="pt-3 text-end px-0">
              <div className='d-inline-block'>
                <h3 className='m-0'>IMO-DCS</h3>
              </div>
            </Col>
          </Row>
          {VesselID > 0 &&
            <ImoDcsPartial vesselId={VesselID} />
          }
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ImoDcs